import { useEffect } from 'react'

export function useDocumentTitle(title: string, deps: ReadonlyArray<any> = []) {
  useEffect(() => {
    document.title = `${title} - Skútan Panta`
  }, deps)
}
